module.exports = __webpack_public_path__ + "static/media/20_plantilla_combo_cuadrada_marco_comida_27.479c69a5.png";